/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './wireless-modem.scss';

/* eslint-disable import/no-unresolved, import/default */

import wirelessModemTemplate from './wireless-modem.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

const SNAKE_CASE_REGEXP = /[A-Z]/g;

export default angular.module('tektelic.wirelessModem', [])
    .directive('tkWirelessModem', WirelessModem)
    .name;

/*@ngInject*/
function WirelessModem() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            gatewayId: '=',
            isReadOnly: '='
        },
        controller: WirelessModemController,
        controllerAs: 'vm',
        templateUrl: wirelessModemTemplate
    };
}

/*@ngInject*/
function WirelessModemController($rootScope, $scope, $element, gatewayCommandService, $translate, $mdExpansionPanelGroup,
                                 $mdExpansionPanel, types, toast, $timeout) {

    var vm = this;

    vm.$onInit = function () {
        vm.types = types;
        vm.$mdExpansionPanel = $mdExpansionPanel;

        vm.deviceInformation = {};
        vm.homeNetwork = {};

        vm.panels = {
            'deviceInformationPanel': {
                command: types.wirelessModemCommand.getWmDeviceInformation.value,
                title: 'wireless-modem.device-information',
                keyTranslatePrefix: 'device-information',
                data: {}
            },
            'homeNetworkPanel': {
                command: types.wirelessModemCommand.getWmHomeNetworkBranch.value,
                title: 'wireless-modem.home-network',
                keyTranslatePrefix: 'home-network',
                data: {}
            },
            'rfInformationPanel': {
                command: types.wirelessModemCommand.getWmRfInformation.value,
                title: 'wireless-modem.rf-information',
                keyTranslatePrefix: 'rf-information',
                data: {}
            },
            'activeProfileParametersPanel': {
                command: types.wirelessModemCommand.getWmActiveProfileParameters.value,
                title: 'wireless-modem.active-profile-parameters',
                keyTranslatePrefix: 'active-profile-parameters',
                data: {}
            },
            'callStatisticsPanel': {
                command: types.wirelessModemCommand.getWmCallStatistics.value,
                title: 'wireless-modem.call-statistics',
                keyTranslatePrefix: 'call-statistics',
                data: {}
            },
            'apnPanel': {
                command: types.wirelessModemCommand.getWmApns.value,
                title: 'wireless-modem.apn',
                keyTranslatePrefix: 'apn',
                data: {}
            }
        };

        vm.loadPanelData = loadPanelData;
        vm.keyTitle = keyTitle;
        vm.addApn = addApn;
        vm.updateApn = updateApn;
        vm.deleteApn = deleteApn;
        vm.switchApnInEditMode = switchApnInEditMode;
        vm.isApnInEditMode = isApnInEditMode;

        resetApnRelatedVariables();

        vm.loading = function () {
            return $rootScope.loading;
        };

        for (var panelId in vm.panels) {
            watchPanelOpened(panelId);
        }
    };

    $scope.$watch('vm.gatewayId', (newVal) => {
        if (newVal) {
            reload();
        }
    });

    function watchPanelOpened(panelId) {
        $scope.$watch(function() {return angular.element('#'+panelId, $element).attr('class'); },
            (newValue, oldValue) => {
                if (newValue && !angular.equals(newValue, oldValue) && newValue.includes('md-open')) {
                    loadPanelData(vm.panels[panelId]);
                }
            }
        );
    }

    function reload() {
        toast.hide();
        $mdExpansionPanelGroup('wmPanelGroup').collapseAll();
        for (var panelId in vm.panels) {
            vm.panels[panelId].data = {};
        }

        resetApnRelatedVariables();
    }

    function loadPanelData(panel) {
        toast.hide();

        if (panel.command === 'getWmApns') {
            resetApnRelatedVariables();
        }

        gatewayCommandService.executeCommand(vm.gatewayId.id, panel.command, {}).then(
            (data) => {
                if (panel.command === 'getWmApns') {
                    panel.data = data.apns;
                    panel.data.workingIdx = data.workingIdx;
                } else {
                    panel.data = data;
                }
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function keyTitle(panel, key) {
        var translationKey = panel.keyTranslatePrefix + '.' + snakeCase(key, '-');
        return $translate.instant(translationKey);
    }

    function snakeCase(name, separator) {
        separator = separator || '_';
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
            return (pos ? separator : '') + letter.toLowerCase();
        });
    }

    function addApn(panel) {
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.wirelessModemCommand.addWmApn.value, {name: vm.apnNewValue}).then(
            () => {
                startStatusApnPooling(panel);
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );

        vm.apnNewValue  = null;
    }

    function updateApn(panel, apn) {
        if (vm.apnEditedValue) {
            apn.name = vm.apnEditedValue;
            vm.apnEditedValue = null;
        }
        vm.apnValueEditMode = null;

        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.wirelessModemCommand.updateWmApn.value, apn).then(
            () => {
                startStatusApnPooling(panel)
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function deleteApn(panel, apn) {
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.wirelessModemCommand.deleteWmApn.value, apn.idxModem).then(
            () => {
                startStatusApnPooling(panel)
            },
            (rejection) => {
                toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
            }
        );
    }

    function switchApnInEditMode(apn) {
        vm.apnStatusMsg = null;
        vm.apnValueEditMode = apn.idx;
        vm.apnEditedValue = apn.name
    }

    function isApnInEditMode(apn) {
        return vm.apnValueEditMode === apn.idx;
    }

    function simStatusIsReady(simStatus) {
        return simStatus && simStatus.indexOf('READY') !== -1;
    }

    function startStatusApnPooling(panel) {
        vm.poolApnStatus = true;
        vm.apnStatusMsg = "APN status: ";
        poolStatusApn(panel);
    }

    function poolStatusApn(panel) {
        $timeout(() => {
            if (!vm.poolApnStatus) {
                return;
            }

            gatewayCommandService.executeCommand(vm.gatewayId.id,
                types.wirelessModemCommand.getWmStatusApn.value, {}).then(
                (response) => {
                    if (simStatusIsReady(response.simStatus) && !apnStatusIsFinal(response.status)) {
                        vm.apnStatusMsg = 'APN status: ' + response.status;
                        poolStatusApn(panel);
                    } else {
                        loadPanelData(panel);

                        if (response.status === 'Deleted') {
                            vm.apnStatusMsg = 'APN status: ' + response.status;
                            return;
                        }

                        if (simStatusIsReady(response.simStatus)) {
                            vm.apnStatusMsg = 'APN status: ' + response.status;
                        } else {
                            vm.apnStatusMsg = 'APN status: ' + $translate.instant('wireless-modem.apn-no-sim-inserted');
                        }
                    }
                },
                (rejection) => {
                    loadPanelData(panel);
                    toast.showError(rejection.data, $element.closest(".toast-parent"), 'bottom left');
                }
            );
        }, 1000);
    }

    function apnStatusIsFinal(apnStatus) {
        return apnStatus === "Deleted"  ||
        apnStatus === "FAIL" ||
        apnStatus === "SUCCESS" ||
        apnStatus === "no changes since last reboot" ||
        apnStatus === "Failed to connect with this APN" ||
        apnStatus === "Maximum number of allowed APNs Reached" ||
        apnStatus === "Connected successfully with this APN";
    }

    function resetApnRelatedVariables() {
        vm.apnNewValue = null;
        vm.apnEditedValue = null;
        vm.apnValueEditMode = null;
        vm.apnStatusMsg = null;
        vm.poolApnStatus = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway/wm/wireless-modem.directive.js